// Source: D:/AI/site-queensbutler/docs/structure/02_基本設計書.md §1-2—1-4
export interface NavLink {
  label: string
  href: string
}

export interface GlobalNavItem extends NavLink {
  children: NavLink[]
}

export type ServiceKey = 'salon' | 'studio' | 'apprentice' | 'shop'

export interface ServiceNavConfig {
  key: ServiceKey
  prefix: `/${ServiceKey}/`
  lockup: string
  subLockup: "Queen's Butler"
  label: string
  links: NavLink[]
  cart?: NavLink
}

export interface FooterNavSection {
  label: string
  links: NavLink[]
}

export const globalNav: GlobalNavItem[] = [
  {
    label: 'はじめての方へ',
    href: '/first-time/',
    children: [
      { label: 'クイーンズバトラーとは', href: '/first-time/about/' },
      { label: '館内のご案内', href: '/first-time/rooms/' },
      { label: 'ご利用の流れ', href: '/first-time/flow/' },
      { label: 'アクセス', href: '/first-time/access/' },
    ],
  },
  {
    label: '執事サロン',
    href: '/salon/',
    children: [
      { label: '執事サロンとは', href: '/salon/about/' },
      { label: 'お過ごし方', href: '/salon/experience/' },
      { label: 'バディとメンバーシップ', href: '/salon/buddy/' },
      { label: '料金', href: '/salon/price/' },
    ],
  },
  {
    label: 'スタジオ・レンタルスペース',
    href: '/studio/',
    children: [
      { label: 'スタジオとは', href: '/studio/about/' },
      { label: '利用用途', href: '/studio/uses/' },
      { label: '空間と設備', href: '/studio/space/' },
      { label: '料金', href: '/studio/price/' },
    ],
  },
  {
    label: '執事見習い体験',
    href: '/apprentice/',
    children: [
      { label: '執事見習い体験とは', href: '/apprentice/about/' },
      { label: '体験の内容', href: '/apprentice/program/' },
      { label: '衣装', href: '/apprentice/wardrobe/' },
      { label: '料金', href: '/apprentice/price/' },
    ],
  },
  {
    label: 'オンラインショップ',
    href: '/shop/',
    children: [
      { label: '新着とおすすめ', href: '/shop/#new-and-recommended' },
      { label: 'カテゴリーから探す', href: '/shop/category/' },
      { label: 'デザインコレクション', href: '/shop/collection/' },
      { label: 'ご購入ガイド', href: '/shop/guide/' },
    ],
  },
]

export const globalContact: NavLink = {
  label: 'お問い合わせ・ご予約',
  href: '/contact/',
}

export const serviceNav: Record<ServiceKey, ServiceNavConfig> = {
  salon: {
    key: 'salon', prefix: '/salon/', lockup: 'THE SALON', subLockup: "Queen's Butler", label: '執事サロン',
    links: [
      { label: '執事サロンとは', href: '/salon/about/' },
      { label: 'お過ごし方', href: '/salon/experience/' },
      { label: 'バディとメンバーシップ', href: '/salon/buddy/' },
      { label: '料金', href: '/salon/price/' },
      { label: 'よくあるご質問', href: '/salon/faq/' },
      { label: 'お問い合わせ・ご予約', href: '/salon/contact/' },
    ],
  },
  studio: {
    key: 'studio', prefix: '/studio/', lockup: 'THE STUDIO', subLockup: "Queen's Butler", label: 'スタジオ・レンタルスペース',
    links: [
      { label: 'スタジオとは', href: '/studio/about/' },
      { label: '利用用途', href: '/studio/uses/' },
      { label: '空間と設備', href: '/studio/space/' },
      { label: '料金', href: '/studio/price/' },
      { label: 'よくあるご質問', href: '/studio/faq/' },
      { label: 'お問い合わせ・ご予約', href: '/studio/contact/' },
    ],
  },
  apprentice: {
    key: 'apprentice', prefix: '/apprentice/', lockup: 'THE FOOTMAN', subLockup: "Queen's Butler", label: '執事見習い体験',
    links: [
      { label: '執事見習い体験とは', href: '/apprentice/about/' },
      { label: '体験の内容', href: '/apprentice/program/' },
      { label: '衣装', href: '/apprentice/wardrobe/' },
      { label: '料金', href: '/apprentice/price/' },
      { label: 'よくあるご質問', href: '/apprentice/faq/' },
      { label: 'お問い合わせ・ご予約', href: '/apprentice/contact/' },
    ],
  },
  shop: {
    key: 'shop', prefix: '/shop/', lockup: 'THE SHOP', subLockup: "Queen's Butler", label: 'オンラインショップ',
    links: [
      { label: 'オンラインショップとは', href: '/shop/about/' },
      { label: '商品一覧', href: '/shop/items/' },
      { label: 'デザインコレクション', href: '/shop/collection/' },
      { label: 'ご購入ガイド', href: '/shop/guide/' },
      { label: 'よくあるご質問', href: '/shop/faq/' },
      { label: 'お問い合わせ', href: '/shop/contact/' },
    ],
    cart: { label: 'カート', href: '/shop/#cart' },
  },
}

export const footerNav: FooterNavSection[] = [
  { label: '全体のご案内', links: [
    { label: 'トップ', href: '/' }, { label: '執事サロン', href: '/salon/' },
    { label: 'スタジオ・レンタルスペース', href: '/studio/' }, { label: '執事見習い体験', href: '/apprentice/' },
    { label: 'オンラインショップ', href: '/shop/' },
  ] },
  { label: '執事を知る', links: [
    { label: '執事を知る', href: '/butler/' }, { label: '執事の服装', href: '/butler/attire/' },
    { label: '執事の作法', href: '/butler/manners/' }, { label: '執事の歴史', href: '/butler/history/' },
    { label: '館と調度の教養', href: '/butler/mansion/' }, { label: '執事の仕事', href: '/butler/work/' },
  ] },
  { label: '執事コラム', links: [{ label: '執事コラム', href: '/column/' }] },
  { label: '各サービスのよくあるご質問', links: [
    { label: '執事サロン', href: '/salon/faq/' }, { label: 'スタジオ・レンタルスペース', href: '/studio/faq/' },
    { label: '執事見習い体験', href: '/apprentice/faq/' }, { label: 'オンラインショップ', href: '/shop/faq/' },
  ] },
  { label: 'キャンセルポリシー', links: [
    { label: '執事サロン', href: '/salon/price/cancel-policy/' }, { label: 'スタジオ・レンタルスペース', href: '/studio/price/cancel-policy/' },
    { label: '執事見習い体験', href: '/apprentice/price/cancel-policy/' }, { label: 'オンラインショップ', href: '/shop/guide/cancel-policy/' },
  ] },
  { label: '採用募集', links: [{ label: '採用募集', href: '/recruit/' }] },
  { label: '運営', links: [
    { label: '会社概要', href: '/company/' }, { label: '利用規約', href: '/terms/' },
    { label: '個人情報の取り扱い', href: '/privacy/' }, { label: '特定商取引法に基づく表記', href: '/tokushoho/' },
    { label: 'お問い合わせ・ご予約', href: '/contact/' },
  ] },
  { label: '関連サイト', links: [
    { label: '関連サイト', href: '/related/' }, { label: '全日本執事協会', href: '/related/association/' },
    { label: 'THE BUTLER', href: '/related/thebutler/' }, { label: '日本執事アカデミー', href: '/related/academy/' },
    { label: '執事ベル', href: '/related/bell/' },
  ] },
]
